<div class="main-menu">
  <app-menu-items
    [ngClass]="{ 'no-bottom-radius': submenuIsVisible }"
    [menuItems]="menuItems$ | async"
    [activeSectionId]="activeSectionId"
    (openSubMenu)="onOpenSubMenu($event)"
  ></app-menu-items>
  <app-submenu-items
    *ngIf="submenuIsVisible"
    [submenus]="subMenu$ | async"
    (linkClicked)="onSubmenuClick($event)"
  ></app-submenu-items>
</div>

<app-regulations-window
  (continue)="setRegulationsAccept()"
  [visible]="isRegulationsVisible$ | async"
  (visibleChange)="hideRegulationsWindow()"
></app-regulations-window>
